import { useWoody } from '../../woody/woody.js';
import { captureException } from '@fabric-app/compat/capabilities/sentry';
import { useMutation } from '@tanstack/react-query';
import { useQueryCachePermissionMemberHelpers } from '../queries/useQueryCachePermissionMembersHelpers.js';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { toast } from '../../store/alerts.js';
import { AnalyticsEvents } from '../../analytics/analytics.types.js';

const useMutationPermissionMemberDelete = () => {
  const { client } = useWoody();
  const { deletePermissionMemberRole } = useQueryCachePermissionMemberHelpers();
  const { track } = useAnalytics();
  return useMutation({
    mutationFn: async ({ resourceId, userId }) => {
      return client.v2({
        endpoint: "/v2/resources/{resourceId}/permissions/{userId}",
        params: {
          resourceId,
          userId
        }
      }, {
        method: "delete"
      });
    },
    onMutate: (variables) => {
      return deletePermissionMemberRole(variables);
    },
    onError: (error, variables, context) => {
      context?.resetCacheToPreOptimisticState();
      toast({
        content: "Failed to remove user from sharing"
      });
      captureException(new Error("Failed to remove user from sharing"), {
        extra: {
          error,
          variables
        }
      });
    },
    onSuccess: (data, variables) => {
      track(AnalyticsEvents.SharingUserRemoved, {
        resourceId: variables.resourceId,
        removedUserId: variables.userId
      });
    },
    onSettled: (data, error, variables, context) => {
      context?.invalidateQueries();
    }
  });
};

export { useMutationPermissionMemberDelete };
//# sourceMappingURL=useMutationPermissionMemberDelete.js.map
